import { z } from 'zod/v4';

export const AdminCompaniesListByPlatformFeatureIdParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminCompaniesListByPlatformFeatureIdParams = z.infer<
  typeof AdminCompaniesListByPlatformFeatureIdParamsSchema
>;

export const AdminCompaniesListByPlatformFeatureIdQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  sort: z
    .string()
    .regex(/^[a-zA-Z]+:(ASC|DESC|asc|desc)$/)
    .optional(),
  filter: z.string().max(512).optional(),
});

export type AdminCompaniesListByPlatformFeatureIdQuery = z.infer<
  typeof AdminCompaniesListByPlatformFeatureIdQuerySchema
>;
